import pkg from "../package.json";

const APP_CONFIG = {
  appName: "Jacana Nature",
  shortName: "Jacana",
  defaultEmail: "jacana.guidenature@gmail.com",
  appDescription: "Reconnecter l'humain à sa nature sauvage.",
  appVersion: pkg.version,
  defaultUserRole: "User",
  userRoles: ["Admin", "Developpeur", "Patron", "Accueillant", "Employe", "User"],
  blockedUserMessage: "Votre accès a été suspendu. Contactez un administrateur.",
  roleRedirects: {
    Admin: "/admin",
    Developpeur: "/admin",
    Accueillant: "/",
    Patron: "/admin",
    Employe: "/",
    User: "/",
  },
  features: {
    notifications: true,
    email: true,
  },
  disabledRoutesByRole: {
    Employe: [],
    Accueillant: [],
    Admin: [],
    Developpeur: [],
    Patron: [],
    User: [],
  },
  // ⚠️ Configuration Firebase déplacée vers les variables d'environnement
  // Voir .env.development et .env.production
};


export default APP_CONFIG; // ✅ maintenant tu peux faire `import APP_CONFIG from ...`
